export default "/images/vendor/flag-icon-css/flags/1x1/lk.svg?93412c6fbb52d5bb809b23a3bc50271d";